import ApiClient from '@/services/apiClient';

export default class ExternalAlarm {
  id;
  name;

  static constructFromObject(data, obj) {
    obj = obj || new ExternalAlarm();
    if (data) {
      obj.id = ApiClient.convertToType(data['id'], 'Integer');
      obj.name = ApiClient.convertToType(data['name'], 'String');
    }
    return obj;
  }
}
